import commonMixin from './commonMixin'

export { commonMixin }
